import MetadataSocialImage from '../assets/images/metadata-social-image.png';

const getMetadataSocialImage = () => {
  return MetadataSocialImage;
};

export default getMetadataSocialImage;
